import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import template from '../../templates/FeatureCreator/ToggleLinkPopup.rt';

class ToggleLinkPopup extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      toggleWarningOff: false
    }
  }
  toggleWarning = () => {
    if(this.props.onChecked) {
      this.props.onChecked(!this.state.toggleWarningOff);
    }
    this.setState({toggleWarningOff: !this.state.toggleWarningOff});
  }
  render() {
    return template.apply(this);
  }
}

ToggleLinkPopup.PropTypes = {
  hasUnlinkedData: PropTypes.bool
}

export {ToggleLinkPopup};
